module.exports = __webpack_public_path__ + "static/media/ServicesProvided.3467ee93.webp";